/* =============================================================================
   agb-turkey-layout.js - the Thanksgiving shooting range. PREVIEW THEMES ONLY.

   This is the full first-person range that grew out of the birthday band:
   the rifle, SEMI/AUTO, a burst you can walk across the page, the words and
   the page taking damage. It was pulled out of agb-birthday-overlay.js so the
   live band could go back to something a shopper can meet without a rifle.

   GATE (fails closed): the file returns immediately unless the theme is a
   preview/unpublished theme - window.__isPreviewTheme === true (set by the
   console gate in theme.liquid) or Shopify.theme.role a known value other
   than 'main'. On the published theme, or when the role cannot be read, it
   does nothing at all. window.AGB_TURKEY_DEV = true is the local harness's
   way in and is never set by the theme.

   TRIGGER: localStorage.turkey_layout === 'true'   (or ?turkey_layout=true)
   KILL SWITCH: window.AGB_TURKEY_OFF = true

   Everything else is documented inline; class names carry the agb-tky
   prefix so the live birthday band and this file never collide.
   ========================================================================== */
(function () {
  'use strict';

  // ------------------------------------------------------------- the gate --
  // Preview themes only. Unknown = not preview = do nothing.
  function previewMode() {
    if (window.AGB_TURKEY_DEV === true) return true;
    if (window.__isPreviewTheme === true) return true;
    if (window.__isLiveTheme === true) return false;
    try {
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      return typeof role === 'string' && role !== '' && role !== 'main';
    } catch (e) { return false; }
  }
  if (!previewMode()) return;

  var KEY = 'turkey_layout';
  var SOUND_KEY = 'turkey_layout_sound';   // 'off' mutes; anything else = on
  var FIRE_KEY = 'turkey_layout_fire';     // 'auto' = hold to fire; anything else = semi
  var AUTO_MS = 90;                           // ~660 rounds a minute

  if (window.AGB_TURKEY_OFF) return;
  if (window.__agbTurkeyLayout) return;      // loaded twice? once is enough
  window.__agbTurkeyLayout = true;

  // ---------------------------------------------------------------- arming --
  // A link can switch the band on or off: the value lands in localStorage and
  // the parameter leaves the URL, so a shared link never re-arms a browser that
  // has since turned it off.
  try {
    var qs = new URLSearchParams(window.location.search);
    if (qs.has(KEY)) {
      localStorage.setItem(KEY, qs.get(KEY) === 'true' ? 'true' : 'false');
      qs.delete(KEY);
      var clean = window.location.pathname + (qs.toString() ? '?' + qs.toString() : '') + window.location.hash;
      window.history.replaceState(null, '', clean);
    }
  } catch (e) { /* storage or history unavailable - stay quiet */ }

  function armed() {
    try { return localStorage.getItem(KEY) === 'true'; } catch (e) { return false; }
  }
  function soundOn() {
    try { return localStorage.getItem(SOUND_KEY) !== 'off'; } catch (e) { return true; }
  }
  function touchDevice() {
    // a finger as the primary pointer (phones, tablets) - not a touch laptop with a mouse
    try { return window.matchMedia('(pointer: coarse)').matches; }
    catch (e) { return navigator.maxTouchPoints > 0; }
  }
  function autoOn() {
    // an explicit choice sticks; with nothing chosen, a phone starts on full
    // auto (hold and slide) and a mouse starts on semi (a round per click)
    var v = null;
    try { v = localStorage.getItem(FIRE_KEY); } catch (e) {}
    if (v === 'auto') return true;
    if (v === 'semi') return false;
    return touchDevice();
  }

  // Brand palette (oxblood, olive, sand, bone, charcoal) - balloons and bunting.
  var COLORS = ['#8f1814', '#92ae74', '#c9b79c', '#f2f2f2', '#3d3d3d', '#b3462f'];

  // The rifle (assets/agb-birthday-rifle-pov.webp): Dorian's first-person
  // picture - gloved hands on an M4 with a holographic sight, the support arm
  // coming in from the bottom-left, the stock running off the right. 1536x800
  // with a transparent background; the flash-hider tip sits at (43.36%, 3.5%).
  // Sized by height; the arm extends well to the left of the pointer, the
  // stock well to the right - that is the point of a first-person view.
  var RIFLE_RATIO = 1536 / 800;
  var RIFLE_MUZZLE = { x: 43.36, y: 3.5 };
  function rifleHeight() { return window.innerWidth < 750 ? 380 : 600; }
  function rifleWidth() { return Math.round(rifleHeight() * RIFLE_RATIO); }

  // Sibling assets (the patch that replaces the logo, the display font, the
  // rifle) live next to this file on the theme CDN; their URLs are derived
  // from ours.
  var SCRIPT_URL = (function () {
    var s = document.currentScript && document.currentScript.src;
    if (!s) {
      var all = document.querySelectorAll('script[src*="agb-turkey-layout"]');
      s = all.length ? all[all.length - 1].src : '';
    }
    return s || '';
  })();
  function siblingAsset(name) {
    if (!SCRIPT_URL) return name;
    // keep this script's ?v= on the sibling: a new push of the script means a
    // fresh fetch of the image and font too, instead of a stale CDN copy
    return SCRIPT_URL.replace(/agb-turkey-layout\.js(?=\?|$)/, name);
  }
  var LOGO_URL = siblingAsset('agb-birthday-logo.webp');
  var RIFLE_URL = siblingAsset('agb-birthday-rifle-pov.webp');

  // ------------------------------------------------------------------- css --
  var CSS = [
    /* the band: a slow-moving colour wash in the brand palette, confetti drifting
       up through it, and a soft vignette so the words stay readable */
    '.agb-tky{position:relative;overflow:hidden;height:200px;color:#f2f2f2;',
    '  background:linear-gradient(115deg,#4a0f0d,#8f1814,#b3462f,#c9b79c,#92ae74,#3f5233,#4a0f0d);',
    '  background-size:320% 320%;animation:agb-tky-wash 16s ease-in-out infinite;',
    '  user-select:none;-webkit-user-select:none;touch-action:manipulation;cursor:none;',
    '  font-family:inherit;box-shadow:inset 0 -1px 0 rgba(255,255,255,.12)}',
    '.agb-tky::before{content:"";position:absolute;inset:-40px 0 0;pointer-events:none;opacity:.9;',
    '  background-image:',
    '    radial-gradient(circle,#ffd23f 0 2px,transparent 3px),',
    '    radial-gradient(circle,#f2f2f2 0 1.5px,transparent 2.5px),',
    '    radial-gradient(circle,#ff6b6b 0 2px,transparent 3px),',
    '    radial-gradient(circle,#7ed6ff 0 1.5px,transparent 2.5px),',
    '    radial-gradient(circle,#c9b79c 0 2px,transparent 3px);',
    '  background-size:140px 120px,90px 160px,170px 140px,110px 130px,200px 180px;',
    '  background-position:0 0,30px 60px,80px 20px,10px 90px,120px 40px;',
    '  animation:agb-tky-confetti 9s linear infinite}',
    '.agb-tky::after{content:"";position:absolute;inset:0;pointer-events:none;',
    '  background:radial-gradient(ellipse at 50% 45%,transparent 35%,rgba(0,0,0,.42) 100%)}',
    '@media (max-width:749px){.agb-tky{height:140px}}',
    /* on full auto the band owns the touch: a sliding finger keeps firing instead of scrolling */
    '.agb-tky.is-auto{touch-action:none}',
    '.agb-tky *{box-sizing:border-box}',
    /* the rest of the page takes fire from a burst walked off the band: bullet
       holes and cracks live in a page-sized layer (they scroll with the page),
       the element itself gets holes cut in, a shake, and finally shards */
    '#agb-tky-damage{position:absolute;left:0;top:0;width:100%;pointer-events:none;z-index:2147482000;overflow:visible}',
    '.agb-tky__hole{position:absolute;width:11px;height:11px;margin:-5.5px 0 0 -5.5px;border-radius:50%;',
    '  background:radial-gradient(circle,#070707 0 34%,#3b3733 52%,rgba(0,0,0,0) 72%);',
    '  box-shadow:0 0 0 1px rgba(0,0,0,.35),0 0 6px rgba(0,0,0,.35);animation:agb-tky-decay 24s linear forwards}',
    '.agb-tky__hole.is-wall{width:8px;height:8px;margin:-4px 0 0 -4px;opacity:.85}',
    '.agb-tky__crack.is-page{background:rgba(10,8,8,.7);animation:agb-tky-decay 24s linear forwards}',
    '.agb-tky-shake{animation:agb-tky-shake .18s ease-out!important}',
    '.agb-tky-gone{visibility:hidden!important}',
    '.agb-tky-heal{animation:agb-tky-back .9s ease-out}',
    '.agb-tky__pshard{position:absolute;margin:0!important;pointer-events:none;animation:agb-tky-shard 1s ease-in forwards}',
    '@keyframes agb-tky-decay{0%,80%{opacity:1}100%{opacity:0}}',
    '@keyframes agb-tky-shake{0%{transform:translate(0,0)}35%{transform:translate(2px,1px)}70%{transform:translate(-1.5px,-1px)}100%{transform:translate(0,0)}}',
    /* the shipping bar above joins the party: colour cycling, a light sweep, a cake */
    '.agb-tky-banner{background:linear-gradient(90deg,#8f1814,#b3462f,#c9b79c,#92ae74,#3f5233,#8f1814)!important;',
    '  background-size:300% 100%!important;animation:agb-tky-shift 7s linear infinite;position:relative;overflow:hidden}',
    '.agb-tky-banner,.agb-tky-banner *{color:#fff!important;text-shadow:0 1px 0 rgba(0,0,0,.35)}',
    '.agb-tky-banner::after{content:"";position:absolute;top:0;bottom:0;left:-40%;width:35%;pointer-events:none;',
    '  background:linear-gradient(100deg,transparent,rgba(255,255,255,.35),transparent);animation:agb-tky-sweep 4s ease-in-out infinite}',
    '.agb-tky-banner .announcement-bar__carousel p::before{content:"\\1F983\\00A0\\00A0"}',
    '.agb-tky-banner .announcement-bar__carousel p::after{content:"\\00A0\\00A0\\1F342"}',
    '@keyframes agb-tky-wash{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}',
    '@keyframes agb-tky-confetti{to{background-position:0 -240px,30px -260px,80px -260px,10px -170px,120px -320px}}',
    '@keyframes agb-tky-shift{to{background-position:300% 0}}',
    '@keyframes agb-tky-sweep{0%,60%{left:-40%}100%{left:110%}}',
    /* the logo swap: the theme's lockup steps aside for the birthday patch */
    '.agb-tky-logo-on .header__logo-image{display:none!important}',
    '.agb-tky-logo-on{height:auto!important;overflow:visible!important}',
    '.agb-tky-logo{display:block;width:auto;max-width:100%;margin:0 auto}',
    /* bunting: a row of little triangles hanging from a string */
    '.agb-tky__bunting{position:absolute;left:0;right:0;top:0;height:22px;pointer-events:none;',
    '  background:',
    '    linear-gradient(135deg,transparent 50%,#8f1814 50%) 0 0/24px 12px repeat-x,',
    '    linear-gradient(45deg,transparent 50%,#8f1814 50%) 0 0/24px 12px repeat-x;',
    '  opacity:.9}',
    '.agb-tky__bunting::before{content:"";position:absolute;left:0;right:0;top:0;height:1px;background:rgba(255,255,255,.45)}',
    '.agb-tky__bunting::after{content:"";position:absolute;left:12px;right:0;top:0;height:22px;',
    '  background:linear-gradient(135deg,transparent 50%,#92ae74 50%) 0 0/48px 12px repeat-x,',
    '             linear-gradient(45deg,transparent 50%,#92ae74 50%) 0 0/48px 12px repeat-x}',
    /* the words */
    /* the storefront's own heading face (Acumin Pro via Adobe Fonts, bold) - the
       same font every heading on the site is set in; the theme's Cabin comes
       next for a sibling store that does not load it */
    '.agb-tky__title{position:absolute;left:0;right:0;top:44%;transform:translateY(-50%);text-align:center;pointer-events:none;',
    '  font-family:acumin-pro,"Agilite Display",Cabin,"Arial Black",sans-serif;',
    '  font-weight:700;letter-spacing:.16em;text-transform:uppercase;font-size:42px;line-height:1;',
    '  text-shadow:0 2px 0 #000,0 0 22px rgba(143,24,20,.6)}',
    '@media (max-width:749px){.agb-tky__title{font-size:22px;letter-spacing:.16em}}',
    /* the letters take fire too: a hole per hit (mask), hairline cracks, a flinch;
       at zero hit points the letter breaks into shards and grows back later */
    '.agb-tky__ch{display:inline-block;position:relative;white-space:pre}',
    '.agb-tky__ch.is-hit{animation:agb-tky-flinch .16s ease-out}',
    '.agb-tky__ch.is-gone{visibility:hidden}',
    '.agb-tky__ch.is-back{animation:agb-tky-back .9s ease-out}',
    '.agb-tky__crack{position:absolute;height:1.5px;background:rgba(25,12,12,.75);transform-origin:0 50%;pointer-events:none}',
    '.agb-tky__shard{position:absolute;visibility:visible;animation:agb-tky-shard .9s ease-in forwards;pointer-events:none}',
    '@keyframes agb-tky-flinch{0%{transform:translate(0,0)}40%{transform:translate(var(--jx),var(--jy))}100%{transform:translate(0,0)}}',
    '@keyframes agb-tky-shard{to{transform:translate(var(--dx),var(--dy)) rotate(var(--rot));opacity:0}}',
    '@keyframes agb-tky-back{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:none}}',
    /* balloons */
    '.agb-tky__sky{position:absolute;inset:0;pointer-events:none}',
    '.agb-tky__balloon{position:absolute;left:var(--x);bottom:-6px;width:var(--w);',
    '  animation:agb-tky-float var(--dur) ease-in-out var(--delay) infinite alternate;will-change:transform}',
    '.agb-tky__body{position:relative;width:var(--w);height:calc(var(--w) * 1.22);',
    '  border-radius:50% 50% 50% 50% / 44% 44% 56% 56%;',
    '  background:radial-gradient(circle at 32% 28%,rgba(255,255,255,.55) 0,rgba(255,255,255,.12) 22%,transparent 40%),var(--c);',
    '  box-shadow:inset -6px -8px 12px rgba(0,0,0,.28)}',
    '.agb-tky__body::after{content:"";position:absolute;left:50%;bottom:-6px;width:0;height:0;transform:translateX(-50%);',
    '  border-left:5px solid transparent;border-right:5px solid transparent;border-top:7px solid var(--c);filter:brightness(.85)}',
    '.agb-tky__string{width:1px;height:22px;margin:8px auto 0;background:rgba(255,255,255,.45);',
    '  transform-origin:top;animation:agb-tky-sway calc(var(--dur) * .6) ease-in-out var(--delay) infinite alternate}',
    '.agb-tky__balloon.is-popping{animation:none}',
    '.agb-tky__balloon.is-popping .agb-tky__body{animation:agb-tky-pop .32s ease-out forwards}',
    '.agb-tky__balloon.is-popping .agb-tky__string{animation:agb-tky-fall .45s ease-in forwards}',
    '.agb-tky__bit{position:absolute;width:7px;height:7px;border-radius:2px;pointer-events:none;',
    '  animation:agb-tky-bit .7s cubic-bezier(.2,.7,.3,1) forwards}',
    /* controls */
    '.agb-tky__score{position:absolute;right:98px;bottom:16px;font-size:11px;letter-spacing:.2em;text-transform:uppercase;',
    '  color:#c9b79c;pointer-events:none}',
    /* fire selector, bottom right: SEMI (a shot per click) or AUTO (hold to fire) */
    /* (two classes on purpose: .agb-tky__btn is declared later and would win on top/width) */
    '.agb-tky__btn.agb-tky__mode{position:absolute;right:12px;bottom:10px;top:auto;width:auto;height:28px;padding:0 12px;',
    '  font-size:10px;letter-spacing:.2em;text-transform:uppercase;font-weight:700}',
    '.agb-tky__btn.agb-tky__mode.is-auto{background:rgba(143,24,20,.9);border-color:#b3462f}',
    '.agb-tky__btn{position:absolute;top:28px;width:30px;height:30px;border:1px solid rgba(255,255,255,.22);border-radius:2px;',
    '  background:rgba(0,0,0,.35);color:#f2f2f2;font:600 13px/1 inherit;cursor:pointer;display:flex;align-items:center;justify-content:center}',
    '.agb-tky__btn:hover{background:rgba(143,24,20,.85);border-color:#8f1814}',
    '.agb-tky__close{right:12px}',
    '.agb-tky__sound{right:48px}',
    '.agb-tky__sound.is-off{opacity:.5}',
    '@media (max-width:749px){.agb-tky__btn{top:26px}.agb-tky__score{display:none}',
    '  .agb-tky__btn.agb-tky__mode{top:auto;bottom:8px;height:24px;padding:0 9px;font-size:9px}}',
    /* first-person layer: fixed over the viewport, never catches a click.
       The rifle is glued to the pointer by its muzzle and leans down-right
       toward the shoulder, which sits below the bottom edge of the screen. */
    '.agb-tky-pov{position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;display:none}',
    '.agb-tky-pov.is-on{display:block}',
    /* three boxes: the outer one is only translated (muzzle onto the pointer),
       the middle one takes the recoil kick, the inner one holds the 3D pose */
    '.agb-tky-pov__gun{position:absolute;left:0;top:0;will-change:transform}',
    '.agb-tky-pov__kick{position:absolute;inset:0;transform-origin:100% 8.5%}',
    '.agb-tky-pov__gun.is-recoil .agb-tky-pov__kick{animation:agb-tky-recoil .14s ease-out}',
    '.agb-tky-pov__gun3d{position:absolute;inset:0;transform-origin:' + RIFLE_MUZZLE.x + '% ' + RIFLE_MUZZLE.y + '%;',
    '  will-change:transform;filter:drop-shadow(0 4px 6px rgba(0,0,0,.45))}',
    '.agb-tky-pov__gun3d img{position:absolute;inset:0;width:100%;height:100%;display:block;pointer-events:none;user-select:none}',
    '.agb-tky-pov__muzzle{position:absolute;width:2px;height:2px;margin:-1px 0 0 -1px;left:' + RIFLE_MUZZLE.x + '%;top:' + RIFLE_MUZZLE.y + '%}',
    '.agb-tky-pov__ret{position:absolute;left:0;top:0;width:28px;height:28px;margin:-14px 0 0 -14px;border-radius:50%;',
    '  border:1.5px solid rgba(255,255,255,.92);box-shadow:0 0 0 1px rgba(0,0,0,.55),inset 0 0 0 1px rgba(0,0,0,.35);will-change:transform}',
    '.agb-tky-pov__ret::before,.agb-tky-pov__ret::after{content:"";position:absolute;background:#fff;box-shadow:0 0 0 1px rgba(0,0,0,.45)}',
    '.agb-tky-pov__ret::before{left:50%;top:-9px;width:1.5px;height:46px;margin-left:-.75px;',
    '  -webkit-mask:linear-gradient(#000 0 9px,transparent 9px 37px,#000 37px);mask:linear-gradient(#000 0 9px,transparent 9px 37px,#000 37px)}',
    '.agb-tky-pov__ret::after{top:50%;left:-9px;height:1.5px;width:46px;margin-top:-.75px;',
    '  -webkit-mask:linear-gradient(90deg,#000 0 9px,transparent 9px 37px,#000 37px);mask:linear-gradient(90deg,#000 0 9px,transparent 9px 37px,#000 37px)}',
    '.agb-tky-pov.is-ui .agb-tky-pov__ret,.agb-tky-pov.is-touch .agb-tky-pov__ret{display:none}',
    '.agb-tky-pov__ret.is-kick{animation:agb-tky-kick .16s ease-out}',
    '.agb-tky-pov__flash{position:absolute;width:52px;height:52px;margin:-26px 0 0 -26px;border-radius:50%;',
    '  background:radial-gradient(circle,#fff8c4 0,#ffd23f 28%,rgba(255,120,0,.85) 52%,transparent 72%);',
    '  animation:agb-tky-flash .12s ease-out forwards}',
    '.agb-tky-pov__hit{position:absolute;width:16px;height:16px;margin:-8px 0 0 -8px;border-radius:50%;',
    '  border:2px solid rgba(255,255,255,.85);animation:agb-tky-hit .3s ease-out forwards}',
    /* motion */
    '@keyframes agb-tky-float{from{transform:translate3d(0,0,0)}to{transform:translate3d(var(--sway),calc(var(--rise) * -1),0)}}',
    '@keyframes agb-tky-sway{from{transform:rotate(-5deg)}to{transform:rotate(5deg)}}',
    '@keyframes agb-tky-pop{0%{transform:scale(1);opacity:1}45%{transform:scale(1.35);opacity:.9}100%{transform:scale(1.6);opacity:0}}',
    '@keyframes agb-tky-fall{to{transform:translateY(60px) rotate(25deg);opacity:0}}',
    '@keyframes agb-tky-bit{0%{transform:translate(0,0) rotate(0);opacity:1}100%{transform:translate(var(--dx),var(--dy)) rotate(540deg);opacity:0}}',
    '@keyframes agb-tky-recoil{0%{transform:rotate(0)}35%{transform:rotate(-2.5deg) translate(4px,6px)}100%{transform:rotate(0)}}',
    '@keyframes agb-tky-kick{0%{scale:1}40%{scale:1.6}100%{scale:1}}',
    '@keyframes agb-tky-flash{0%{opacity:1;scale:.5}100%{opacity:0;scale:1.7}}',
    '@keyframes agb-tky-hit{0%{opacity:1;scale:.4}100%{opacity:0;scale:2.4}}',
    '@media (prefers-reduced-motion:reduce){.agb-tky__balloon,.agb-tky__string{animation:none}',
    '  .agb-tky__balloon{bottom:14px}}'
  ].join('\n');

  // The rifle as you hold it. The perspective is baked into the render, so
  // the only transform is a small sway. A marker rides on the muzzle tip and
  // its on-screen position is what the placement code reads: the outer box
  // is shifted until that marker sits on the pointer.
  var RIFLE_HTML =
    '<div class="agb-tky-pov__kick"><div class="agb-tky-pov__gun3d">' +
    '<img src="' + RIFLE_URL + '" alt="" decoding="async" draggable="false">' +
    '<i class="agb-tky-pov__muzzle"></i>' +
    '</div></div>';

  // --------------------------------------------------------------- helpers --
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(list) { return list[Math.floor(Math.random() * list.length)]; }
  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  function mountPoint() {
    var bar = document.querySelector('[data-announcement-bar], .announcement-bar');
    var wrap = bar && (bar.closest('.shopify-section') || bar);
    if (wrap) return { node: wrap, where: 'afterend' };
    var header = document.querySelector('.shopify-section .header, header.header, #shopify-section-header');
    var hw = header && (header.closest('.shopify-section') || header);
    if (hw) return { node: hw, where: 'beforebegin' };
    return { node: document.body, where: 'afterbegin' };
  }

  // ---------------------------------------------------------------- sound --
  var audio = null;
  function ctx() {
    if (!soundOn()) return null;
    try {
      if (!audio) audio = new (window.AudioContext || window.webkitAudioContext)();
      if (audio.state === 'suspended') audio.resume();
      return audio;
    } catch (e) { return null; }
  }
  function shotSound() {
    var c = ctx(); if (!c) return;
    var t = c.currentTime, n = Math.floor(c.sampleRate * 0.12);
    var buf = c.createBuffer(1, n, c.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, 3);
    var src = c.createBufferSource(); src.buffer = buf;
    var f = c.createBiquadFilter(); f.type = 'lowpass';
    f.frequency.setValueAtTime(2200, t); f.frequency.exponentialRampToValueAtTime(250, t + 0.12);
    var g = c.createGain(); g.gain.setValueAtTime(0.22, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.13);
    src.connect(f); f.connect(g); g.connect(c.destination); src.start(t);
  }
  function popSound() {
    var c = ctx(); if (!c) return;
    var t = c.currentTime;
    var o = c.createOscillator(); o.type = 'triangle';
    o.frequency.setValueAtTime(880, t); o.frequency.exponentialRampToValueAtTime(140, t + 0.09);
    var g = c.createGain(); g.gain.setValueAtTime(0.28, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.11);
    o.connect(g); g.connect(c.destination); o.start(t); o.stop(t + 0.12);
  }
  function thudSound(broke) {
    // a round hitting a board: short, dull; a breaking letter gets a longer crunch
    var c = ctx(); if (!c) return;
    var t = c.currentTime, dur = broke ? 0.22 : 0.07, n = Math.floor(c.sampleRate * dur);
    var buf = c.createBuffer(1, n, c.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, broke ? 1.5 : 2.5);
    var src = c.createBufferSource(); src.buffer = buf;
    var f = c.createBiquadFilter(); f.type = 'bandpass'; f.frequency.value = broke ? 900 : 500; f.Q.value = 0.8;
    var g = c.createGain(); g.gain.setValueAtTime(broke ? 0.3 : 0.16, t); g.gain.exponentialRampToValueAtTime(0.001, t + dur);
    src.connect(f); f.connect(g); g.connect(c.destination); src.start(t);
  }

  // ----------------------------------------------------------------- band --
  var band = null, sky = null, scoreEl = null;
  var popped = 0, touchHide = 0;

  function balloonCount() { return window.innerWidth < 750 ? 5 : 8; }

  function makeBalloon(i, total) {
    var b = el('div', 'agb-tky__balloon');
    var small = window.innerWidth < 750;
    var w = Math.round(small ? rnd(30, 42) : rnd(38, 58));
    // spread across the width, clear of the buttons on the right
    var slot = (i + 0.5) / total;
    var x = small ? 8 + slot * 70 : 6 + slot * 84;
    b.style.setProperty('--x', Math.round(x + rnd(-3, 3)) + '%');
    b.style.setProperty('--w', w + 'px');
    b.style.setProperty('--c', pick(COLORS));
    b.style.setProperty('--dur', rnd(5, 9).toFixed(2) + 's');
    b.style.setProperty('--delay', (-rnd(0, 8)).toFixed(2) + 's');
    b.style.setProperty('--rise', Math.round(small ? rnd(14, 30) : rnd(30, 70)) + 'px');
    b.style.setProperty('--sway', Math.round(rnd(-18, 18)) + 'px');
    b.appendChild(el('div', 'agb-tky__body'));
    b.appendChild(el('div', 'agb-tky__string'));
    b._slot = i; b._total = total;
    return b;
  }

  function burst(x, y, color, count) {
    for (var i = 0; i < (count || 10); i++) {
      var bit = el('span', 'agb-tky__bit');
      var a = rnd(0, Math.PI * 2), dist = rnd(24, 70);
      bit.style.left = x + 'px'; bit.style.top = y + 'px';
      bit.style.background = i % 3 === 0 ? pick(COLORS) : color;
      bit.style.setProperty('--dx', Math.round(Math.cos(a) * dist) + 'px');
      bit.style.setProperty('--dy', Math.round(Math.sin(a) * dist + 20) + 'px');
      sky.appendChild(bit);
      setTimeout(function (n) { n.remove(); }.bind(null, bit), 800);
    }
  }

  function popBalloon(b, x, y) {
    if (b.classList.contains('is-popping')) return;
    b.classList.add('is-popping');
    burst(x, y, b.style.getPropertyValue('--c'));
    popSound();
    popped += 1;
    scoreEl.textContent = popped + ' popped';
    document.dispatchEvent(new CustomEvent('agb:tky-pop', { detail: { count: popped } }));
    var slot = b._slot, total = b._total;
    setTimeout(function () {
      var fresh = makeBalloon(slot, total);
      b.replaceWith(fresh);
    }, 900);
  }

  // --------------------------------------------------------- the letters --
  // "Happy Birthday" is one span per character. A letter takes LETTER_HP
  // rounds: every hit punches a hole through it (a radial-gradient mask layer,
  // all layers intersected), throws a few hairline cracks from the hole, makes
  // it flinch and spits debris. At zero it shatters into shards that fall away,
  // and it grows back after a while so the band never stays wordless.
  var LETTER_HP = 5, LETTER_BACK_MS = 12000;
  var titleEl = null;

  function buildTitle(text) {
    titleEl = el('div', 'agb-tky__title');
    text.split('').forEach(function (ch) {
      var s = el('span', 'agb-tky__ch');
      s.textContent = ch;
      s._hp = ch === ' ' ? 0 : LETTER_HP;
      s._holes = [];
      titleEl.appendChild(s);
    });
    return titleEl;
  }
  function letterAt(clientX, clientY) {
    if (!titleEl) return null;
    var list = titleEl.querySelectorAll('.agb-tky__ch:not(.agb-tky__shard)');
    for (var i = 0; i < list.length; i++) {
      var s = list[i]; if (!(s._hp > 0) || !s._holes) continue;   // spaces, gone letters, clones
      var r = s.getBoundingClientRect();
      if (clientX >= r.left - 1 && clientX <= r.right + 1 && clientY >= r.top - 2 && clientY <= r.bottom + 2) return s;
    }
    return null;
  }
  function hitLetter(s, clientX, clientY, bandX, bandY) {
    var r = s.getBoundingClientRect();
    var lx = clientX - r.left, ly = clientY - r.top;
    s._hp -= 1;
    var hr = 2.5 + Math.random() * 3.5;
    s._holes.push('radial-gradient(circle at ' + lx.toFixed(1) + 'px ' + ly.toFixed(1) + 'px,transparent 0 ' + hr.toFixed(1) + 'px,#000 ' + (hr + 1.2).toFixed(1) + 'px)');
    s.style.webkitMaskImage = s.style.maskImage = s._holes.join(',');
    s.style.webkitMaskComposite = 'source-in';
    s.style.maskComposite = 'intersect';
    for (var i = 0; i < 2 + Math.floor(Math.random() * 2); i++) {
      var c = el('i', 'agb-tky__crack');
      c.style.left = lx + 'px'; c.style.top = ly + 'px';
      c.style.width = (5 + Math.random() * 11) + 'px';
      c.style.transform = 'rotate(' + Math.round(Math.random() * 360) + 'deg)';
      s.appendChild(c);
    }
    s.style.setProperty('--jx', (Math.random() * 3 - 1.5).toFixed(1) + 'px');
    s.style.setProperty('--jy', (1 + Math.random() * 2).toFixed(1) + 'px');
    s.classList.remove('is-hit'); void s.offsetWidth; s.classList.add('is-hit');
    burst(bandX, bandY, '#f2f2f2', 5);
    if (s._hp <= 0) shatterLetter(s); else thudSound(false);
  }
  function shatterLetter(s) {
    thudSound(true);
    var left = s.offsetLeft, top = s.offsetTop;
    for (var k = 0; k < 5; k++) {
      var shard = s.cloneNode(true);
      shard.className = 'agb-tky__ch agb-tky__shard';
      shard.style.left = left + 'px'; shard.style.top = top + 'px';
      var x0 = k * 20, x1 = (k + 1) * 20, j = (Math.random() * 12 - 6).toFixed(1);
      shard.style.clipPath = 'polygon(' + x0 + '% 0%,' + (x1 + +j) + '% 0%,' + (x1 - j) + '% 100%,' + x0 + '% 100%)';
      shard.style.setProperty('--dx', Math.round(Math.random() * 70 - 35) + 'px');
      shard.style.setProperty('--dy', Math.round(50 + Math.random() * 90) + 'px');
      shard.style.setProperty('--rot', Math.round(Math.random() * 160 - 80) + 'deg');
      shard.style.animationDelay = (Math.random() * 0.08).toFixed(2) + 's';
      titleEl.appendChild(shard);
      setTimeout(function (n) { n.remove(); }.bind(null, shard), 1100);
    }
    s.classList.add('is-gone');
    setTimeout(function () { restoreLetter(s); }, LETTER_BACK_MS);
  }
  function restoreLetter(s) {
    if (!s.isConnected) return;
    s._hp = LETTER_HP; s._holes = [];
    s.style.maskImage = s.style.webkitMaskImage = '';
    Array.prototype.forEach.call(s.querySelectorAll('.agb-tky__crack'), function (c) { c.remove(); });
    s.classList.remove('is-gone', 'is-hit');
    s.classList.add('is-back');
    setTimeout(function () { s.classList.remove('is-back'); }, 1000);
  }

  // ---------------------------------------------------- the rest of the page --
  // A burst that starts on the band can be walked across the page (a finger
  // sliding, a mouse dragging). Rounds that land off the band hit whatever is
  // there: a bullet hole + cracks go into a page-sized decal layer, and the
  // element under the round loses hit points the way a letter does - holes
  // cut in with a mask, a shake, shards at zero, healed after a while. Big
  // containers count as walls: they only get the hole.
  var PAGE_HP = 6, PAGE_HEAL_MS = 15000, MAX_DECALS = 220;
  var damageLayer = null, damaged = [];
  var TARGET_TAGS = { IMG: 1, SVG: 1, PICTURE: 1, VIDEO: 1, A: 1, BUTTON: 1, H1: 1, H2: 1, H3: 1, H4: 1, H5: 1, H6: 1,
    P: 1, SPAN: 1, LI: 1, LABEL: 1, STRONG: 1, EM: 1, SUMMARY: 1, INPUT: 1, SELECT: 1, FIGURE: 1 };

  function layer() {
    if (!damageLayer) {
      damageLayer = el('div'); damageLayer.id = 'agb-tky-damage';
      document.body.appendChild(damageLayer);
    }
    damageLayer.style.height = document.documentElement.scrollHeight + 'px';
    return damageLayer;
  }
  function decal(pageX, pageY, wall) {
    var L = layer();
    var hole = el('i', 'agb-tky__hole' + (wall ? ' is-wall' : ''));
    hole.style.left = pageX + 'px'; hole.style.top = pageY + 'px';
    L.appendChild(hole);
    for (var i = 0; i < (wall ? 2 : 3); i++) {
      var c = el('i', 'agb-tky__crack is-page');
      c.style.left = pageX + 'px'; c.style.top = pageY + 'px';
      c.style.width = (6 + Math.random() * 14) + 'px';
      c.style.transform = 'rotate(' + Math.round(Math.random() * 360) + 'deg)';
      L.appendChild(c);
    }
    while (L.children.length > MAX_DECALS) L.firstChild.remove();
  }
  function pickTarget(node) {
    var vw = window.innerWidth, vh = window.innerHeight, n = node, depth = 0;
    while (n && n !== document.body && depth < 5) {
      if (TARGET_TAGS[n.tagName]) {
        var r = n.getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.width * r.height < vw * vh * 0.6) return n;
      }
      n = n.parentElement; depth++;
    }
    var r0 = node.getBoundingClientRect();
    if (node !== document.body && node !== document.documentElement && r0.width * r0.height < vw * vh * 0.25) return node;
    return null;                                   // a wall
  }
  function damagePage(clientX, clientY) {
    var under = document.elementFromPoint(clientX, clientY);
    if (!under) return false;
    if (under.closest('#agb-tky, #agb-tky-pov, #agb-tky-damage, iframe, #preview-bar-iframe, .agb-tky__pshard')) return false;
    var t = pickTarget(under);
    decal(clientX + window.scrollX, clientY + window.scrollY, !t);
    if (!t) { thudSound(false); return 'wall'; }
    if (t._agbHp === undefined) {
      t._agbHp = PAGE_HP; t._agbHoles = [];
      t._agbMask0 = [t.style.maskImage, t.style.webkitMaskImage, t.style.maskComposite, t.style.webkitMaskComposite];
      damaged.push(t);
    }
    if (t._agbHp <= 0) return 'wall';
    t._agbHp -= 1;
    var r = t.getBoundingClientRect();
    var hr = 3 + Math.random() * 4;
    t._agbHoles.push('radial-gradient(circle at ' + (clientX - r.left).toFixed(1) + 'px ' + (clientY - r.top).toFixed(1) + 'px,transparent 0 ' + hr.toFixed(1) + 'px,#000 ' + (hr + 1.5).toFixed(1) + 'px)');
    t.style.webkitMaskImage = t.style.maskImage = t._agbHoles.join(',');
    t.style.webkitMaskComposite = 'source-in'; t.style.maskComposite = 'intersect';
    if (getComputedStyle(t).transform === 'none') {
      t.classList.remove('agb-tky-shake'); void t.offsetWidth; t.classList.add('agb-tky-shake');
    }
    if (t._agbHp <= 0) { shatterElement(t); thudSound(true); } else thudSound(false);
    return 'page';
  }
  function shatterElement(t) {
    var r = t.getBoundingClientRect(), L = layer();
    var px = r.left + window.scrollX, py = r.top + window.scrollY;
    for (var k = 0; k < 5; k++) {
      var shard = t.cloneNode(true);
      shard.removeAttribute('id'); shard.className = 'agb-tky__pshard';
      shard.style.left = px + 'px'; shard.style.top = py + 'px';
      shard.style.width = r.width + 'px'; shard.style.height = r.height + 'px';
      shard.style.maskImage = shard.style.webkitMaskImage = '';
      var x0 = k * 20, x1 = (k + 1) * 20, j = (Math.random() * 12 - 6);
      shard.style.clipPath = 'polygon(' + x0 + '% 0%,' + (x1 + j).toFixed(1) + '% 0%,' + (x1 - j).toFixed(1) + '% 100%,' + x0 + '% 100%)';
      shard.style.setProperty('--dx', Math.round(Math.random() * 90 - 45) + 'px');
      shard.style.setProperty('--dy', Math.round(60 + Math.random() * 120) + 'px');
      shard.style.setProperty('--rot', Math.round(Math.random() * 140 - 70) + 'deg');
      shard.style.animationDelay = (Math.random() * 0.1).toFixed(2) + 's';
      L.appendChild(shard);
      setTimeout(function (n) { n.remove(); }.bind(null, shard), 1200);
    }
    t.classList.add('agb-tky-gone');
    setTimeout(function () { healElement(t); }, PAGE_HEAL_MS);
  }
  function healElement(t) {
    if (t._agbHp === undefined) return;
    var m = t._agbMask0 || ['', '', '', ''];
    t.style.maskImage = m[0]; t.style.webkitMaskImage = m[1]; t.style.maskComposite = m[2]; t.style.webkitMaskComposite = m[3];
    t.classList.remove('agb-tky-gone', 'agb-tky-shake');
    if (t.isConnected) { t.classList.add('agb-tky-heal'); setTimeout(function () { t.classList.remove('agb-tky-heal'); }, 1000); }
    delete t._agbHp; delete t._agbHoles; delete t._agbMask0;
    var i = damaged.indexOf(t); if (i >= 0) damaged.splice(i, 1);
  }
  function healAll() {
    damaged.slice().forEach(healElement);
    if (damageLayer) { damageLayer.remove(); damageLayer = null; }
  }

  // Which balloon is under this band-relative point? Elliptical test on the
  // body, because a click on the string or just outside the curve is a miss.
  function balloonAt(px, py) {
    var origin = band.getBoundingClientRect();
    var list = sky.querySelectorAll('.agb-tky__balloon:not(.is-popping) .agb-tky__body');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      var cx = r.left - origin.left + r.width / 2, cy = r.top - origin.top + r.height / 2;
      var rx = r.width / 2 + 3, ry = r.height / 2 + 3;      // a little forgiveness
      var dx = (px - cx) / rx, dy = (py - cy) / ry;
      if (dx * dx + dy * dy <= 1) return list[i].parentNode;
    }
    return null;
  }

  // ------------------------------------------------------- first person --
  // The rifle lives in a fixed layer over the whole viewport (the band is only
  // 200px tall and clips its children; a rifle you are holding has to run off
  // the bottom of the screen). Its muzzle chases the pointer with a little lag
  // so it sways like something with weight, and it leans a few degrees with
  // where you aim - the perspective itself is baked into the render.
  var pov = null, gun = null, gun3d = null, muzzle = null, ret = null;
  var aiming = false, tx = 0, ty = 0, gx = 0, gy = 0, raf = 0;
  var wx = 0, wy = 0;            // where the outer box currently sits

  function pose(lean) {
    return 'rotate(' + lean.toFixed(2) + 'deg)';
  }
  function sizeGun() {
    gun.style.width = rifleWidth() + 'px';
    gun.style.height = rifleHeight() + 'px';
  }
  function centre(node) {
    var r = node.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  function wantedLean() {
    // a touch steeper when aiming right, flatter when aiming left
    var fx = clamp(gx / Math.max(1, window.innerWidth), 0, 1);
    return (fx - 0.5) * 10;
  }
  function place() {
    var lag = clamp((tx - gx) * 0.06, -5, 5);   // the barrel trails a fast hand
    gun3d.style.transform = pose(wantedLean() + lag);
    // now read where the projected muzzle landed and shift the outer box so it
    // sits exactly on (gx, gy) - translation is the one thing perspective
    // leaves alone, so one correction is exact
    gun.style.transform = 'translate(' + wx.toFixed(1) + 'px,' + wy.toFixed(1) + 'px)';
    var m = centre(muzzle);
    wx += gx - m.x; wy += gy - m.y;
    gun.style.transform = 'translate(' + wx.toFixed(1) + 'px,' + wy.toFixed(1) + 'px)';
    ret.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px)';
  }
  function tick() {
    raf = 0;
    if (!aiming) return;
    gx += (tx - gx) * 0.3;
    gy += (ty - gy) * 0.3;
    place();
    if (Math.abs(tx - gx) > 0.15 || Math.abs(ty - gy) > 0.15) raf = requestAnimationFrame(tick);
  }
  function aimStart(x, y, touch) {
    tx = x; ty = y;
    if (!aiming) { gx = x + 40; gy = y + 90; }   // the rifle comes up from below
    aiming = true;
    pov.classList.add('is-on');
    pov.classList.toggle('is-touch', !!touch);
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function aimMove(x, y) {
    tx = x; ty = y;
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function aimStop() {
    aiming = false;
    pov.classList.remove('is-on');
  }

  function shoot(clientX, clientY, bandX, bandY, burst) {
    // recoil on the rifle, a kick on the reticle, flash + impact where you aimed
    gun.classList.remove('is-recoil'); void gun.offsetWidth; gun.classList.add('is-recoil');
    ret.classList.remove('is-kick'); void ret.offsetWidth; ret.classList.add('is-kick');
    // driven into the shoulder, then settles; lighter per round on full auto
    if (burst) { gx += 3; gy += 5; } else { gx += 7; gy += 11; }
    if (!raf) raf = requestAnimationFrame(tick);

    var flash = el('div', 'agb-tky-pov__flash');
    flash.style.left = clientX + 'px'; flash.style.top = clientY + 'px';
    pov.appendChild(flash); setTimeout(function () { flash.remove(); }, 150);

    var hit = el('div', 'agb-tky-pov__hit');
    hit.style.left = clientX + 'px'; hit.style.top = clientY + 'px';
    pov.appendChild(hit); setTimeout(function () { hit.remove(); }, 320);

    shotSound();
    // the words are drawn above the balloons, so they take the round first;
    // a round that lands off the band hits the page
    var struck = false;
    var o = band.getBoundingClientRect();
    var onBand = clientX >= o.left && clientX <= o.right && clientY >= o.top && clientY <= o.bottom;
    if (onBand) {
      var letter = letterAt(clientX, clientY);
      if (letter) { hitLetter(letter, clientX, clientY, bandX, bandY); struck = 'letter'; }
      else {
        var target = balloonAt(bandX, bandY);
        if (target) { popBalloon(target, bandX, bandY); struck = 'balloon'; }
      }
    } else {
      struck = damagePage(clientX, clientY);
    }
    document.dispatchEvent(new CustomEvent('agb:tky-shot', { detail: { x: bandX, y: bandY, hit: struck } }));
  }

  function bandPoint(evt) {
    var o = band.getBoundingClientRect();
    return { x: evt.clientX - o.left, y: evt.clientY - o.top };
  }

  // Full auto: while the button is held, a round every AUTO_MS at wherever
  // the pointer is now. The release is caught on the window, so letting go
  // outside the band still stops it.
  var burstTimer = 0, burstX = 0, burstY = 0;
  function burstStart(clientX, clientY) {
    burstStop();
    burstX = clientX; burstY = clientY;
    burstTimer = setInterval(function () {
      if (!band) { burstStop(); return; }
      var o = band.getBoundingClientRect();
      shoot(burstX, burstY, burstX - o.left, burstY - o.top, true);
    }, AUTO_MS);
    window.addEventListener('pointerup', burstStop);
    window.addEventListener('pointercancel', burstStop);
    window.addEventListener('blur', burstStop);
  }
  function burstStop() {
    if (burstTimer) {
      clearInterval(burstTimer); burstTimer = 0;
      if (pov && pov.classList.contains('is-touch')) {   // a finger let go: the rifle stays up a moment
        clearTimeout(touchHide);
        touchHide = setTimeout(aimStop, 2200);
      }
    }
    window.removeEventListener('pointerup', burstStop);
    window.removeEventListener('pointercancel', burstStop);
    window.removeEventListener('blur', burstStop);
  }

  // ------------------------------------------------------------ the logo --
  // While the band is up, the header lockup steps aside for the birthday
  // patch. The theme's own <img> is hidden, not removed, so restoring is a
  // class flip. The patch is sized from the header as it stands BEFORE the
  // swap, so the header does not grow: as tall as the lockup it replaces,
  // never taller than the header minus a little breathing room.
  var logoHost = null, logoImg = null;
  function swapLogo() {
    var host = document.querySelector('.header__logo');
    if (!host || logoImg) return;
    var target = host.querySelector('a') || host;
    var theirs = host.querySelector('.header__logo-image');
    var header = host.closest('x-header, .header') || host.parentElement;
    var headerH = header ? header.getBoundingClientRect().height : 0;
    var theirsH = theirs ? theirs.getBoundingClientRect().height : 0;
    var h = Math.min(theirsH || 64, headerH ? headerH - 12 : 64);
    h = clamp(Math.round(h), 36, 96);
    logoImg = el('img', 'agb-tky-logo');
    logoImg.src = LOGO_URL;
    logoImg.alt = 'Agilite';
    logoImg.decoding = 'async';
    logoImg.style.height = h + 'px';
    host.classList.add('agb-tky-logo-on');
    target.appendChild(logoImg);
    logoHost = host;
  }
  function restoreLogo() {
    if (logoImg) { logoImg.remove(); logoImg = null; }
    if (logoHost) { logoHost.classList.remove('agb-tky-logo-on'); logoHost = null; }
  }
  function overButton(evt) {
    return !!(evt.target && evt.target.closest && evt.target.closest('.agb-tky__btn'));
  }

  function mount() {
    if (band || !document.body) return;
    // one band at a time: the live birthday band steps aside for the range
    try { if (window.AGB_BirthdayOverlay) window.AGB_BirthdayOverlay.hide(); } catch (e) {}
    var style = el('style', null, CSS); style.id = 'agb-tky-css';
    document.head.appendChild(style);

    band = el('div', 'agb-tky'); band.id = 'agb-tky';
    band.setAttribute('role', 'region'); band.setAttribute('aria-label', 'Thanksgiving range');
    band.appendChild(el('div', 'agb-tky__bunting'));

    sky = el('div', 'agb-tky__sky');
    var n = balloonCount();
    for (var i = 0; i < n; i++) sky.appendChild(makeBalloon(i, n));
    band.appendChild(sky);

    // after the sky on purpose: the words stay readable, balloons drift behind
    // them - and the words are targets in their own right
    band.appendChild(buildTitle('Happy Thanksgiving'));

    scoreEl = el('div', 'agb-tky__score', '0 popped');
    band.appendChild(scoreEl);

    var sound = el('button', 'agb-tky__btn agb-tky__sound', '&#9835;');
    sound.type = 'button'; sound.setAttribute('aria-label', 'Sound on or off');
    if (!soundOn()) sound.classList.add('is-off');
    sound.addEventListener('click', function (e) {
      e.stopPropagation();
      var off = soundOn();
      try { localStorage.setItem(SOUND_KEY, off ? 'off' : 'on'); } catch (x) {}
      sound.classList.toggle('is-off', off);
    });
    band.appendChild(sound);

    var close = el('button', 'agb-tky__btn agb-tky__close', '&times;');
    close.type = 'button'; close.setAttribute('aria-label', 'Close the Thanksgiving band');
    close.addEventListener('click', function (e) {
      e.stopPropagation();
      try { localStorage.setItem(KEY, 'false'); } catch (x) {}
      unmount();
    });
    band.appendChild(close);

    var mode = el('button', 'agb-tky__btn agb-tky__mode', autoOn() ? 'Auto' : 'Semi');
    mode.type = 'button'; mode.setAttribute('aria-label', 'Fire selector: semi or auto');
    mode.classList.toggle('is-auto', autoOn());
    band.classList.toggle('is-auto', autoOn());
    mode.addEventListener('click', function (e) {
      e.stopPropagation();
      var next = autoOn() ? 'semi' : 'auto';
      try { localStorage.setItem(FIRE_KEY, next); } catch (x) {}
      mode.textContent = next === 'auto' ? 'Auto' : 'Semi';
      mode.classList.toggle('is-auto', next === 'auto');
      band.classList.toggle('is-auto', next === 'auto');
      if (next !== 'auto') burstStop();
    });
    band.appendChild(mode);

    // the first-person layer
    pov = el('div', 'agb-tky-pov'); pov.id = 'agb-tky-pov';
    gun = el('div', 'agb-tky-pov__gun', RIFLE_HTML);
    gun3d = gun.querySelector('.agb-tky-pov__gun3d');
    muzzle = gun.querySelector('.agb-tky-pov__muzzle');
    sizeGun();
    window.addEventListener('resize', function () { if (gun) sizeGun(); });
    ret = el('div', 'agb-tky-pov__ret');
    pov.appendChild(gun); pov.appendChild(ret);
    document.body.appendChild(pov);

    // the rifle is up only while the pointer is over the band
    band.addEventListener('pointerenter', function (evt) {
      if (evt.pointerType === 'touch') return;
      aimStart(evt.clientX, evt.clientY, false);
    });
    band.addEventListener('pointerleave', function (evt) {
      if (evt.pointerType === 'touch') return;
      aimStop();
    });
    band.addEventListener('pointermove', function (evt) {
      burstX = evt.clientX; burstY = evt.clientY;          // a burst follows the pointer
      if (evt.pointerType === 'touch') { if (burstTimer) aimMove(evt.clientX, evt.clientY); return; }
      pov.classList.toggle('is-ui', overButton(evt));
      if (!aiming) aimStart(evt.clientX, evt.clientY, false); else aimMove(evt.clientX, evt.clientY);
    });
    // one handler for mouse, pen and touch: aim at the point, then fire
    band.addEventListener('pointerdown', function (evt) {
      if (overButton(evt)) return;
      evt.preventDefault();
      var p = bandPoint(evt);
      var touch = evt.pointerType === 'touch';
      if (!aiming || touch) aimStart(evt.clientX, evt.clientY, touch); else aimMove(evt.clientX, evt.clientY);
      gx = tx; gy = ty; place();                 // no lag on the shot itself
      shoot(evt.clientX, evt.clientY, p.x, p.y, false);
      if (autoOn()) {
        // keep receiving the pointer while the button is held, even off the band
        try { band.setPointerCapture(evt.pointerId); } catch (x) {}
        burstStart(evt.clientX, evt.clientY);
      }
      if (touch) {                               // no hover on a phone: keep the rifle up a moment
        clearTimeout(touchHide);
        if (!burstTimer) touchHide = setTimeout(aimStop, 2200);   // a burst sets it when it ends
      }
    });

    var at = mountPoint();
    at.node.insertAdjacentElement(at.where, band);
    swapLogo();
    dressBanner();
  }

  // the announcement bar joins in while the band is up (class flip, nothing else)
  var bannerEl = null;
  function dressBanner() {
    bannerEl = document.querySelector('[data-announcement-bar], .announcement-bar');
    if (bannerEl) bannerEl.classList.add('agb-tky-banner');
  }
  function undressBanner() {
    if (bannerEl) { bannerEl.classList.remove('agb-tky-banner'); bannerEl = null; }
  }

  function unmount() {
    if (!band) return;
    burstStop();
    aimStop();
    healAll();
    restoreLogo();
    undressBanner();
    band.remove(); band = null; sky = null; scoreEl = null;
    if (pov) { pov.remove(); pov = null; gun = null; ret = null; }
    var s = document.getElementById('agb-tky-css'); if (s) s.remove();
  }

  // ----------------------------------------------------------------- boot --
  // For the console and for anything else on the page: show/hide on demand,
  // and how many balloons have gone so far.
  window.AGB_TurkeyLayout = {
    show: mount,
    hide: unmount,
    armed: armed,
    popped: function () { return popped; }
  };

  function boot() { if (armed()) mount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Another tab flipped the switch: follow it without a reload.
  window.addEventListener('storage', function (evt) {
    if (evt.key !== KEY) return;
    if (evt.newValue === 'true') mount(); else unmount();
  });
})();
